import { render } from "./dark-mode-button.vue?vue&type=template&id=1c16afd8"
import script from "./dark-mode-button.vue?vue&type=script&lang=js"
export * from "./dark-mode-button.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__